// Helper utility to view localStorage data in console
// Usage: Import and call functions, or use in browser console

export const viewData = {
  // View all patients
  patients: () => {
    const patients = JSON.parse(localStorage.getItem('medicalcrm_patients') || '[]');
    console.log('📋 Total Patients:', patients.length);
    console.table(patients);
    return patients;
  },

  // View all sales
  sales: () => {
    const sales = JSON.parse(localStorage.getItem('medicalcrm_sales') || '[]');
    console.log('💰 Total Sales:', sales.length);
    console.table(sales);
    return sales;
  },

  // View all purchases
  purchases: () => {
    const purchases = JSON.parse(localStorage.getItem('medicalcrm_purchases') || '[]');
    console.log('🛒 Total Purchases:', purchases.length);
    console.table(purchases);
    return purchases;
  },

  // View all users
  users: () => {
    const users = JSON.parse(localStorage.getItem('medicalcrm_users') || '[]');
    console.log('👤 Total Users:', users.length);
    // Remove passwords for display
    const usersWithoutPasswords = users.map(({ password, ...user }) => user);
    console.table(usersWithoutPasswords);
    return usersWithoutPasswords;
  },

  // View settings
  settings: () => {
    const settings = JSON.parse(localStorage.getItem('medicalcrm_settings') || 'null');
    console.log('⚙️ Settings:', settings);
    return settings;
  },

  // View current user
  currentUser: () => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    console.log('👤 Current User:', user);
    return user;
  },

  // View everything
  all: () => {
    console.log('📊 All Medical CRM Data:');
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    viewData.patients();
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    viewData.sales();
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    viewData.purchases();
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    viewData.users();
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    viewData.settings();
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    viewData.currentUser();
  },

  // Count all records
  counts: () => {
    const counts = {
      patients: JSON.parse(localStorage.getItem('medicalcrm_patients') || '[]').length,
      sales: JSON.parse(localStorage.getItem('medicalcrm_sales') || '[]').length,
      purchases: JSON.parse(localStorage.getItem('medicalcrm_purchases') || '[]').length,
      users: JSON.parse(localStorage.getItem('medicalcrm_users') || '[]').length,
    };
    console.table(counts);
    return counts;
  },

  // Find patient by name
  findPatient: (name) => {
    const patients = JSON.parse(localStorage.getItem('medicalcrm_patients') || '[]');
    const found = patients.filter(p => 
      (p.patient_name || p.patientName || '').toLowerCase().includes(name.toLowerCase())
    );
    console.log(`🔍 Found ${found.length} patient(s) matching "${name}":`);
    console.table(found);
    return found;
  },

  // Get latest patient
  latestPatient: () => {
    const patients = JSON.parse(localStorage.getItem('medicalcrm_patients') || '[]');
    const latest = patients[patients.length - 1];
    if (latest) {
      console.log('📝 Latest Patient:');
      console.log(latest);
    } else {
      console.log('No patients found');
    }
    return latest;
  },
};

// Make available globally in browser console
if (typeof window !== 'undefined') {
  window.viewData = viewData;
  console.log('✅ Data viewing helpers loaded!');
  console.log('💡 Use: viewData.patients(), viewData.sales(), viewData.all(), etc.');
}

